import React from "react";
import { Link } from "react-router-dom";

const MaterialTailwindCard = ({img, tittle, desc, button, link, imageStyle}) => {
  return (
    <div className="flex justify-center items-center p-3 mt-10 mb-10">
      <div className="max-w-[720px] mx-auto">

        <div className="relative justify-between h-[470px] bg-gray flex flex-col text-gray-700 bg-white shadow-sm bg-clip-border rounded-xl max-w-80">
          <div className="flex justify-center items-center h-56 relative overflow-hidden text-white shadow-md bg-clip-border rounded-xl bg-blue-gray-500 bg-color1">
            <img
              src={img}
              alt="card-image"
              className={`${imageStyle} h-full object-cover flex justify-center items-center`}
            />
            <div className="absolute inset-0 bg-hover opacity-30" />

          </div>
          <div className="p-6">
            <h5 className="block mb-2 font-quantico text-xl antialiased font-semibold leading-snug tracking-normal text-background">
              {tittle}
            </h5>
            <p className="block font-roboto text-base antialiased leading-relaxed text-inherit text-background">
              {desc}
            </p>
          </div>
          <div className="p-6 pt-0">
            <Link
              className={`${button} block align-middle bg-hover select-none font-sans font-bold text-center uppercase transition-all disabled:opacity-50 disabled:shadow-none disabled:pointer-events-none text-xs py-3 px-6 rounded-lg bg-gray-900 text-white shadow-md shadow-gray-900/10 hover:shadow-lg hover:shadow-gray-900/20 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none `}
              type="button"
              to={link}
            >
              Learn More
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MaterialTailwindCard;

